import Image from "next/image";
import React, { useEffect, useRef } from "react";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import styles from "./style.module.scss";

import left_light_arrow from "../../../public/images/home/left-light-arrow.svg";
import { toWebp } from "../../../utils/common";

const Banner = ({ data }) => {
  const divRef = useRef(null);

  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL;

  useEffect(() => {
    const imageUrl = toWebp(baseUrl + data?.image?.data?.attributes?.url);

    divRef.current.style.backgroundImage = `url(${imageUrl})`;
  }, [data, baseUrl]);

  return (
    <section
      ref={divRef}
      className={`${styles["home-banner-section"]} ${styles["contact-banner-section"]} ${styles["case-study-banner-section"]}`}
    >
      <Container className={styles["container"]}>
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className={styles["case-studies-back-btn"]}>
              <Link href="/case-studies" className={`btn text-white text-ex-small  font-medium ${styles["btn-primary"]}`}>
                <Image
                  src={left_light_arrow}
                  alt="case-stud"
                  width={10}
                  height={10}
                />
                Case Studies
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Banner;
